import * as React from "react"

import Layout from "../../../components/layout"
import Seo from "../../../components/seo"
import Product from "../../../components/ProductDisplayPage/Product"
import Details from "../../../components/ProductDisplayPage/Details"
import PdpStorage from "../../../components/Shop/Stoarge/PdpStorage"
import PdpColors from "../../../components/ProductDisplayPage/Pdp-Colour"
import Radio from "../../../components/ProductDisplayPage/Radio"
import Accessories from "../../../components/ProductDisplayPage/Accessories"
import Accessory from "../../../components/ProductDisplayPage/Accessory"

const S21Ultra = () => (
  <Layout>
    <Seo title="Samsung Galaxy S21 Ultra" />
    <div className="Screen PDP">
      <div className="PDP-Page">
        <Product
          device="Samsung Galaxy S21 Ultra"
          image="https://shop.ee.co.uk/medias/samsung-galaxy-s21-ultra-silver-no-gwp-front-gallery-Format-237?context=bWFzdGVyfHJvb3R8MTQxMzh8aW1hZ2UvanBlZ3xzeXMtbWFzdGVyL3Jvb3QvaDkzL2hmYy85NjIyMzk1NTg0NTQyL3NhbXN1bmctZ2FsYXh5LXMyMS11bHRyYS1zaWx2ZXItbm8tZ3dwLWZyb250LWdhbGxlcnlfRm9ybWF0LTIzN3xkNjhhYzM3NWUxZDZiYmVkYWQ3NzYzOWNkOGU2NGM2MzQzMTc0NTIyMTdhOTM2NTQ2NDc5ZTQ5OWJjODlhMWNh"
        />
        <Details
          price="1199"
          storage={
            <div className="PDP-Storage">
              <PdpStorage radionumber="1" capacity="128" price="956" />
              <PdpStorage radionumber="2" capacity="256" price="1011" />
              <PdpStorage radionumber="3" capacity="512" price="1200" />
            </div>
          }
          colours={
            <div className="PDP-Color-Grid">
              <PdpColors colour="black" radionumber="4" />
              <PdpColors colour="silver" radionumber="5" />
            </div>
          }
          colour="red"
          connection={
            <div className="PDP-Split">
              <Radio
                radionumber="5"
                label="New"
                labelclass="PDP-Connection-Label"
                description="Device will require a new Sim"
                descriptionclass="PDP-Connection-Description"
              />
              <Radio
                radionumber="6"
                label="Upgrade"
                labelclass="PDP-Connection-Label"
                description="Device will be allocated to an existing user"
                descriptionclass="PDP-Connection-Description"
              />
            </div>
          }
          accessories={
            <Accessories
              note="**Please note this device does not come with a charger."
              accessory={
                <Accessory
                  image="https://shop.ee.co.uk/content/dam/everything-everywhere/images/SHOP/Devices/EP-PN920_001_Front_Black.jpg.eeimg.320.1-1.medium.jpg"
                  device="Samsung wireless quick charger"
                  price="24.00"
                />
              }
            />
          }
        />
      </div>
    </div>
  </Layout>
)

export default S21Ultra
